//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

const INSTAGRAM_WEB_HASHTAG_LINK = (hashtag: string) =>
  `https://www.instagram.com/explore/tags/${hashtag}/`;
const INSTAGRAM_WEB_LOCATION_LINK = (locationId: string) =>
  `https://www.instagram.com/explore/locations/${locationId}/`;
const INSTAGRAM_WEB_USER_LINK = (username: string) =>
  `https://www.instagram.com/${username}/`;
const INSTAGRAM_WEB_USER_IFRAME_LINK = (username: string) =>
  `https://instagram.com/${username}/embed`;

export const InstagramWebLinks = {
  getHashtagLink: INSTAGRAM_WEB_HASHTAG_LINK,
  getLocationLink: INSTAGRAM_WEB_LOCATION_LINK,
  getUserIframeLink: INSTAGRAM_WEB_USER_IFRAME_LINK,
  getUserLink: INSTAGRAM_WEB_USER_LINK,
};

const PINTEREST_WEB_USER_LINK = (username: string) =>
  `https://www.pinterest.com/${username}/`;

export const PinterestWebLinks = {
  getUserLink: PINTEREST_WEB_USER_LINK,
};

const TIKTOK_WEB_USER_LINK = (username: string) =>
  `https://www.tiktok.com/@${username}/`;

const TIKTOK_WEB_HASHTAG_LINK = (tag: string) =>
  `https://www.tiktok.com/tag/${tag}`;

const YOUTUBE_WEB_USER_LINK = (username: string) =>
  `https://www.youtube.com/@${username}`;

const YOUTUBE_EMBED_LINK = (videoId: string) =>
  `https://www.youtube.com/embed/${videoId}`;

const YOUTUBE_HASHTAG_LINK = (hashtag: string) =>
  `https://www.youtube.com/hashtag/${hashtag}`;

const VIMEO_EMBED_LINK = (videoId: string) =>
  `https://player.vimeo.com/video/${videoId}`;

const GOOGLE_DRIVE_EMBED_LINK = (videoId: string) =>
  `https://drive.google.com/file/d/${videoId}/preview`;

export const TikTokWebLinks = {
  getUserLink: TIKTOK_WEB_USER_LINK,
  getHashtagLink: TIKTOK_WEB_HASHTAG_LINK,
};

export const YouTubeWebLinks = {
  getUserLink: YOUTUBE_WEB_USER_LINK,
  getHashtagLink: YOUTUBE_HASHTAG_LINK,
  getEmbedLink: YOUTUBE_EMBED_LINK,
};

export const VimeoWebLinks = {
  getEmbedLink: VIMEO_EMBED_LINK,
};

export const GoogleDriveWebLinks = {
  getEmbedLink: GOOGLE_DRIVE_EMBED_LINK,
};

const TWITTER_WEB_HASHTAG_LINK = (hashtag: string) =>
  `https://www.twitter.com/hashtag/${hashtag}/`;
const TWITTER_WEB_USER_LINK = (username: string) =>
  `https://www.twitter.com/${username}`;

export const TwitterWebLinks = {
  getHashtagLink: TWITTER_WEB_HASHTAG_LINK,
  getUserLink: TWITTER_WEB_USER_LINK,
};

const FACEBOOK_WEB_USER_LINK = (username: string) =>
  `https://facebook.com/${username}`;

export const FacebookWebLinks = {
  getUserLink: FACEBOOK_WEB_USER_LINK,
};
